import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Command, Condition, QuestionOption } from '@empathy/survey/base';
import { IMediaForm } from '@empathy/survey-core';

import { IQuestionOptionForm } from './question-form-group.interface';
import { ConditionForm } from '../conditions/condition-form.model';

export class QuestionOptionForm {
  form = new FormGroup<IQuestionOptionForm>({
    id: new FormControl<string>(''),
    text: new FormControl<string>(''),
    value: new FormControl<string>(''),
    stimulus: new FormGroup<IMediaForm>({
      mediaId: new FormControl<string>(''),
      name: new FormControl<string>(''),
      type: new FormControl<string>('')
    }),
    exclusiveInd: new FormControl<boolean>(false),
    pinnedPositionInd: new FormControl<boolean>(false),
    visibleWhen: new FormArray([]),
    selectedWhen: new FormArray([])
  });

  constructor(question?: QuestionOption, initId: string = 'opt_1') {
    if (!question) {
      this.form.get('id').setValue(initId);
      this.form.get('value').setValue('1');
      return;
    }

    this.form.patchValue(question);
    this.patchVisibleWhen(question.visibleWhen);
    this.patchSelectedWhen(question.selectedWhen);
  }

  private patchVisibleWhen(visibleWhen: (Condition | Command)[]): void {
    if (!visibleWhen || visibleWhen.length === 0) {
      return;
    }

    visibleWhen.forEach((condition) => {
      if (typeof condition === 'object') {
        (this.form.get('visibleWhen') as FormArray).push(new ConditionForm(condition as Condition).form);
      } else {
        (this.form.get('visibleWhen') as FormArray).push(new FormControl(condition as Command));
      }
    });
  }

  private patchSelectedWhen(selectedWhen: (Condition | Command)[]): void {
    if (!selectedWhen || selectedWhen.length === 0) {
      return;
    }

    selectedWhen.forEach((condition) => {
      if (typeof condition === 'object') {
        (this.form.get('selectedWhen') as FormArray).push(new ConditionForm(condition as Condition).form);
      } else {
        (this.form.get('selectedWhen') as FormArray).push(new FormControl(condition as Command));
      }
    });
  }
}
